import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData            from '../primitives/localData'

import lmx_Events               from './Events'
import lmx_Watching             from './Watching'

import set_LocalValues          from './set_LocalValues'
import draw_Forms               from './draw_Forms'
import draw_Summary             from './draw_Summary'
import draw_Header              from './draw_Header'

import draw_Viewbox             from './draw_Viewbox'
import draw_DataGrid            from './draw_DataGrid'
import export_PDF               from './PDF'


export default {
  
  mixins: [
    gmx_zMixins, 
    lmx_localData,

    // Local Mixins
    lmx_Events,
    lmx_Watching,
    
    set_LocalValues,
    draw_Forms,
    draw_Summary,
    draw_Header,
    
    draw_Viewbox,
    draw_DataGrid ,
    export_PDF,
  ],

}
